export default __webpack_public_path__ + "static/media/questionnaire.eb755e4d.svg";